import { useEffect, useState } from 'react';

const WA_LINK = 'https://wa.me/5521990212845?text=Ol%C3%A1,%20vi%20o%20site%20do%20M%C3%A9todo%20Equilibradamente%20e%20gostaria%20de%20saber%20mais%20sobre%20a%20sess%C3%A3o%20gratuita.';
const SCROLL_THRESHOLD = 500;

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <style>{`
        @keyframes float-pulse {
          0%, 100% { box-shadow: 0 0 10px rgba(37,211,102,0.30), 0 4px 16px rgba(37,211,102,0.18); }
          50%       { box-shadow: 0 0 20px rgba(37,211,102,0.45), 0 6px 24px rgba(37,211,102,0.28); }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div
        className="fixed z-50"
        style={{
          bottom: 28,
          left: '50%',
          transform: 'translateX(-50%)',
          pointerEvents: visible ? 'auto' : 'none',
          opacity: visible ? 1 : 0,
          transition: 'opacity 0.4s ease',
          animation: visible ? 'slide-up 0.4s ease forwards' : 'none',
        }}
      >
        <a
          href={WA_LINK}
          target="_blank"
          rel="noreferrer"
          className="whitespace-nowrap flex items-center gap-2 font-semibold rounded-full cursor-pointer"
          style={{
            background: hovered
              ? 'linear-gradient(135deg, #20C55A, #17A348)'
              : 'linear-gradient(135deg, #25D366, #1DB954)',
            color: '#FFFFFF',
            fontSize: 13,
            paddingLeft: 22,
            paddingRight: 22,
            paddingTop: 12,
            paddingBottom: 12,
            animation: 'float-pulse 3.2s ease-in-out infinite',
            transform: hovered ? 'scale(1.03)' : 'scale(1)',
            transition: 'background 0.2s, transform 0.2s',
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
            <i className="ri-whatsapp-line text-sm" style={{ color: '#FFFFFF' }} />
          </span>

          Falar no WhatsApp

          <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
            <i
              className="ri-arrow-right-line text-sm"
              style={{
                color: '#FFFFFF',
                transform: hovered ? 'translateX(3px)' : 'translateX(0)',
                transition: 'transform 0.2s',
              }}
            />
          </span>
        </a>
      </div>
    </>
  );
}
